 <template>
     <div class="col-md-12 text-center">
         <ul class="pagination">
             <li class="first" v-bind:class="(currentPage == 1) ? 'disabled' : ''" v-on:click.prevent="onPageClick(1)"><a href="#">First</a></li>
             <li class="prev" v-bind:class="(currentPage == 1) ? 'disabled' : ''" v-on:click.prevent="onPageClick(currentPage - 1)"><a href="#">Previous</a></li>
             <li class="page" v-for="page in pagesNumbers" v-bind:class="(currentPage == page) ? 'active' : ''"  v-on:click.prevent="onPageClick(page)">
                 <a href="javascript:void(0);">
                     {{ page }}
                 </a>
             </li>
             <li class="next" v-bind:class="(currentPage == pageCount) ? 'disabled' : ''" v-on:click.prevent="onPageClick(currentPage + 1)"><a href="#">Next</a></li>
             <li class="last" v-bind:class="(currentPage == pageCount) ? 'disabled' : ''" v-on:click.prevent="onPageClick(pageCount)"><a href="#">Last</a></li>
         </ul>
     </div>
 </template>

<script>
    export default {
        props: {
            'pageCount': {
                type: Number,
                required: true
            },
            'currentPage': {
                type: Number,
                required: true
            },
            'callback': {
                type: Function,
                required: true
            },
            'showPageCountMax': {
                type: Number,
                required: false,
                default: 10
            },
        },
        computed: {
            startPage: function () {
                var startPageDiff = Math.floor(this.showPageCountMax / 2);
                var startPage = (this.currentPage - startPageDiff) < 1 ? 1 : this.currentPage - startPageDiff;
                return startPage;
            },

            pagesNumbers: function () {
                const pagesNumbers = Array.from(new Array(this.showPageCountMax > this.pageCount ? this.pageCount : this.showPageCountMax),(val,index) => index + this.startPage)

                for (let i = pagesNumbers.length - 1; i >= 0; i--) {
                    if (pagesNumbers[i] > this.pageCount) {
                        pagesNumbers.splice(i, 1);
                    }
                }

                return pagesNumbers;
            },
        },
        name: 'pagination',
        methods: {
            onPageClick: function(pageNumber) {
                if(pageNumber > 0 && pageNumber <= this.pageCount)
                    this.callback(pageNumber);
            },
        },
    };
</script>
